<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div class="w-full h-12 hidden sm:flex"></div>
    <div class="card flex flex-col bg-white rounded max-w-sm w-full">
      <div class="flex flex-col w-full space-y-2">
        <button class="nxp-back-btn hidden sm:flex" @click="handleBackward">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
              <rect width="16" height="16" fill="#696969" />
            </mask>
            <g mask="url(#mask0_857_10485)">
              <path
                d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                fill="#A9A9A9" />
            </g>
          </svg>
          Voltar
        </button>
        <span v-if="jobPositionReference" class="nxp-job-title">
          {{ jobPositionReference }}
        </span>
        <h1 class="nxp-title-form">
          Adicione sua formação
        </h1>
        <span class="nxp-subtitle-form">
          Informe o que você estudou ou está estudando.
        </span>
      </div>


      <div class="w-full flex flex-col space-y-4 mt-8">
        <div class="w-full flex flex-col items-center py-4">

          <div class="nxp-ia-description-container">
            <img src="@/assets/images/re_formation.png" alt="Rê com barrete de formatura">
            <div>
              <h3>
                Devo extrair as formações/cursos do seu currículo?
              </h3>
              <p>
                Isto é importante para mostrar seu percurso educacional
              </p>
            </div>
          </div>
          <button class="nxp-btn-ia" :style="{ borderColor: color, background: backgroundColor }"
            @click="generateFormationsFromCV()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
              <path
                d="M10.0812 11.3476C10.028 11.6505 9.84171 11.7991 9.5793 11.8861C9.05919 12.0587 8.53542 12.2233 8.02559 12.423C7.11795 12.7784 6.54989 13.458 6.24788 14.3728C6.10994 14.7906 5.9768 15.21 5.83463 15.6264C5.71376 15.9804 5.52198 16.137 5.22893 16.1386C4.93435 16.1403 4.73754 15.984 4.61801 15.6337C4.46348 15.1808 4.32341 14.723 4.16765 14.2705C3.78537 13.1601 2.97518 12.5241 1.87473 12.2073C1.51891 12.1049 1.1669 11.9877 0.817628 11.8645C0.511747 11.7567 0.357975 11.5401 0.363936 11.2627C0.369791 10.9904 0.517432 10.7872 0.816888 10.6836C1.21795 10.5448 1.62373 10.4194 2.02893 10.2929C3.11877 9.95252 3.83805 9.24016 4.18691 8.15316C4.32136 7.73427 4.44533 7.31154 4.59501 6.89815C4.74579 6.48172 5.11577 6.29955 5.44984 6.48888C5.5905 6.56859 5.72099 6.72579 5.78059 6.87745C5.93838 7.27894 6.05947 7.69524 6.18709 8.10814C6.55409 9.29555 7.36422 10.0101 8.54281 10.3443C8.9138 10.4495 9.27926 10.5755 9.64351 10.7027C9.96689 10.8157 10.0695 10.9722 10.0812 11.3476Z"
                :fill="color" />
              <path
                d="M11.4657 4.05876C10.6959 4.3243 10.233 4.85066 10.0164 5.60957C9.95078 5.83951 9.86658 6.0642 9.78899 6.29064C9.71441 6.50828 9.57699 6.64765 9.33133 6.6435C9.09749 6.63956 9.00477 6.48489 8.93115 6.28937C8.76032 5.83568 8.60741 5.37116 8.3888 4.9407C8.16731 4.50459 7.76477 4.24544 7.30516 4.08525C7.01352 3.98361 6.71965 3.88842 6.42763 3.78785C6.22256 3.71722 6.07906 3.60093 6.07959 3.35589C6.08012 3.1104 6.22602 2.99613 6.43039 2.92582C6.71514 2.82786 7.00201 2.73602 7.28626 2.63667C7.93852 2.40869 8.39026 1.97558 8.62099 1.31964C8.71833 1.04293 8.81475 0.765891 8.91168 0.489031C9.00763 0.214958 9.17015 0.0633201 9.3763 0.0748295C9.62951 0.0889664 9.75223 0.258586 9.82545 0.478985C9.91797 0.757442 10.0089 1.03646 10.1053 1.31358C10.3197 1.92989 10.7459 2.34044 11.3498 2.56922C11.6673 2.68952 11.9895 2.79779 12.3111 2.90693C12.518 2.97713 12.6777 3.09892 12.6844 3.32751C12.6914 3.56727 12.5385 3.70258 12.3174 3.77337C12.038 3.86282 11.7609 3.95958 11.4657 4.05876Z"
                :fill="color" />
            </svg>
            Extrair formações
          </button>

        </div>
      </div>

      <div class="flex w-full flex-col mt-10 mb-6 space-y-2">
        <h3 class="nxp-section-title">
          Formações
        </h3>
        <hr class="custom-hr">
      </div>

      <div class="w-full flex flex-col space-y-2">
        <div class="w-full flex flex-col items-center">
          <p class="w-full pb-8 flex justify-center items-center" v-if="formations.length == 0">
            Você ainda não inseriu nenhuma formação
          </p>

          <div class="w-full flex flex-col space-y-4">
            <div class="nxp-card-item" v-for="(item, index) in formations" :key="`formation-card-${index}`">
              <div class="nxp-vertical-bar" :style="{ background: color }"></div>
              <div class="w-full flex flex-col space-y-1">
                <div class="w-full flex flex-col">
                  <b>
                    <p class="mb-1">
                      {{ instituteAndScholarity(item) }}
                    </p>
                  </b>
                  <p class="mb-1">
                    {{ gradeAndLevel(item) }}
                  </p>
                  <p class="mb-1">
                    {{ fromAndTo(item) }}
                  </p>
                </div>
                <div class="w-full flex flex-row space-x-2">
                  <button @click="goToSaveFormation(item)" class="nxp-card-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path
                        d="M5.1805 15.722H6.10675L14.3038 7.52492L13.3776 6.59867L5.1805 14.7958V15.722ZM4.09717 16.8053V14.3391L14.4643 3.95596C14.5763 3.84152 14.697 3.76006 14.8261 3.71159C14.9553 3.66298 15.0906 3.63867 15.2322 3.63867C15.3738 3.63867 15.509 3.66138 15.6378 3.7068C15.7667 3.75221 15.8915 3.83263 16.0122 3.94805L16.9465 4.8743C17.062 4.99499 17.1437 5.11999 17.1918 5.2493C17.2398 5.3786 17.2638 5.51173 17.2638 5.64867C17.2638 5.79464 17.2386 5.93395 17.188 6.06659C17.1373 6.19923 17.0568 6.32048 16.9465 6.43034L6.56342 16.8053H4.09717ZM13.8326 7.06992L13.3776 6.59867L14.3038 7.52492L13.8326 7.06992Z"
                        fill="#4F4F4F" />
                    </svg>
                    Editar
                  </button>
                  <button class="nxp-card-button" @click="handleRemovePopupActive(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                      <path
                        d="M7.43696 16.8067C7.06724 16.8067 6.75147 16.6759 6.48967 16.4142C6.228 16.1524 6.09717 15.8367 6.09717 15.467V5.72341H5.09717V4.64008H8.6805V3.73633H12.6805V4.64008H16.2638V5.72341H15.2638V15.458C15.2638 15.8433 15.1343 16.1644 14.8753 16.4213C14.6163 16.6783 14.2992 16.8067 13.924 16.8067H7.43696ZM14.1805 5.72341H7.1805V15.467C7.1805 15.5418 7.20453 15.6033 7.25258 15.6513C7.30064 15.6994 7.3621 15.7234 7.43696 15.7234H13.924C13.9882 15.7234 14.047 15.6967 14.1003 15.6432C14.1538 15.5899 14.1805 15.5311 14.1805 15.467V5.72341ZM9.01717 14.2234H10.1003V7.22341H9.01717V14.2234ZM11.2607 14.2234H12.3438V7.22341H11.2607V14.2234Z"
                        fill="#4F4F4F" />
                    </svg>
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="formations.length > 0" class=" flex w-full h-10">
          </div>

          <button class="nxp-new-formation-btn" @click="goToSaveFormation(null)">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <path
                d="M7.89315 8.83019H2.24951V7.31746H7.89315V1.67383H9.40587V7.31746H15.0495V8.83019H9.40587V14.4738H7.89315V8.83019Z"
                fill="#4F4F4F" />
            </svg>
            Adicionar formação
          </button>

        </div>
      </div>
      <button class="nxp-continue-btn mt-16" :style="{ background: color }" @click="handleForward">{{ isEdit() ? "Salvar"
        : 'Continuar' }}</button>
    </div>

    <vs-popup title="" :active.sync="removePopupActive">
      <div class="nxp-modal-content">
        <h2 class="nxp-modal-title mb-4 flex items-center">
          <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M2.06543 20.25L11.9999 3.75L21.9344 20.25H2.06543ZM4.37493 18.95H19.6249L11.9999 6.25L4.37493 18.95ZM11.9947 17.5577C12.1937 17.5577 12.3623 17.4904 12.5004 17.3558C12.6386 17.2211 12.7077 17.0542 12.7077 16.8552C12.7077 16.6562 12.6403 16.4877 12.5057 16.3495C12.371 16.2113 12.2042 16.1423 12.0052 16.1423C11.8062 16.1423 11.6376 16.2096 11.4994 16.3442C11.3613 16.4789 11.2922 16.6458 11.2922 16.8448C11.2922 17.0438 11.3595 17.2123 11.4942 17.3505C11.6288 17.4887 11.7957 17.5577 11.9947 17.5577ZM11.3499 14.9423H12.6499V10.1423H11.3499V14.9423Z"
              fill="#DE2348" />
          </svg>
          Excluindo formação
        </h2>
        <p class="nxp-modal-paragraph mb-8">
          Tem certeza que você quer excluir a formação
          <b>{{ formationToRemove.scholarity }} - {{ formationToRemove.institute }}</b>?
          <br /><br />
          <b>Atenção!</b> esta ação é permanente e não poderá ser desfeita
        </p>
        <div class="flex flex-row space-x-2">
          <button class="nxp-secondary-btn" @click="removePopupActive = false" color="dark" type="flat">
            Manter formação
          </button>
          <button class="nxp-cancel-btn" @click="handleRemoveFormation" color="danger" type="filled">
            Excluir formação
          </button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";
import { isBefore } from "date-fns";
import vSelect from "vue-select";

export default {
  data: () => ({
    formationToRemove: {},
    removePopupActive: false,
    jobPositionReference: localStorage.getItem("vacancy_name"),
  }),
  computed: {
    ...mapState("auth", ["auth"]),
    ...mapState("formation", ["higherEducation", "formation"]),
    ...mapGetters("formation", ["formations"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },

    backgroundColor() {
      return this.company.base_hexcolor
        ? this.company.base_hexcolor + '2D'
        : "#1551b12D";
    },
  },
  created() {
    this.$validator.extend(
      "compareDate",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique as datas de início e saída",
        validate: (value, [otherValue]) => {
          return new Promise((resolve) => {
            if (otherValue == "")
              resolve({
                valid: false,
                data: { message: "A data de início está vazia!" },
              });

            const splitFrom = "01/".concat(otherValue).split("/");
            const splitTo = "01/".concat(value).split("/");

            const monthReg = /0[1-9]|1[0-2]/;
            const yearReg = /(?:(?:19|20)[0-9]{2})/;

            if (!splitFrom[1].match(monthReg))
              resolve({
                valid: false,
                data: {
                  message: `O mês ${splitFrom[1]} informado na data de início não é válido!`,
                },
              });
            if (!splitTo[1].match(monthReg))
              resolve({
                valid: false,
                data: {
                  message: `O mês ${splitTo[1]} informado não é válido!`,
                },
              });

            if (!splitFrom[2].match(yearReg))
              resolve({
                valid: false,
                data: {
                  message: `O ano ${splitFrom[2]} informado na data de início não é válido!`,
                },
              });
            if (!splitTo[2].match(yearReg))
              resolve({
                valid: false,
                data: {
                  message: `O ano ${splitTo[2]} informado não é válido!`,
                },
              });

            const from = new Date(splitFrom[2], splitFrom[1] - 1, splitFrom[0]);
            const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

            resolve({
              valid: isBefore(from, to),
              data: {
                message: `${isBefore(from, to)
                  ? ""
                  : "A data de finalização não pode ser menor que a data de início"
                  }`,
              },
            });
          });
        },
      },
      { hasTarget: true, immediate: false }
    );

    this.fetchFormations();
    window.scroll(0, 0);
  },
  methods: {
    isEdit() {
      return this.$router.history.current.path.includes('edit')
    },
    handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }

      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },

    async handleForward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail",
        });
        return;
      }
      await this.$store.dispatch("step/completeStep");

      await this.$store.dispatch("step/incrementCurrentStep");

      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    fetchFormations() {
      this.$vs.loading();

      const { company_label } = this.$router.history.current.params;

      this.$http
        .get(`api/v1/talent/${company_label}/user/talent?step=formations`)
        .then((response) => {
          this.$vs.loading.close();

          const { formations } = response.data.data;

          this.$store.dispatch("formation/index", formations);
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },

    async generateFormationsFromCV() {
      const maxAttempts = 3;
      const waitTime = 10000; // 10 seconds
      const timeout = 45000;

      // Inicia o loading inicial
      this.$vs.loading({
        text: "Aguarde! Lendo CV e analisando formações..."
      });

      const makeAttempt = async (attemptNumber) => {
        // Apenas atualiza o texto do loading para tentativas subsequentes
        if (attemptNumber > 1) {
          const loadingMessage = attemptNumber === 2 
            ? "Extraindo dados do CV..."
            : "Criando as formações...";
            
          this.$vs.loading({
            text: loadingMessage
          });
        }

        let isTimeout = false;
        const timeoutHandler = setTimeout(() => {
          isTimeout = true;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Tempo limite excedido",
            text: "Tente novamente mais tarde.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
          this.fetchFormations();
        }, timeout);

        try {
          const response = await this.$http.post('/api/v2/assistant/chat', {
            feature: 'talent_curriculum_content_generate',
            feature_data: {
              talent_id: this.auth.user.talent.id,
              data_type: "formations"
            }
          });
          
          clearTimeout(timeoutHandler);
          
          if (isTimeout) return false;

          if (response.data.answer !== null) {
            this.$vs.loading.close();
            window.woopra.track("generate-formations-clicked", {
              'formations': response.data.answer
            });
            this.fetchFormations();
            return true;
          }
          
          return false;
        } catch (error) {
          clearTimeout(timeoutHandler);
          console.log(`Tentativa ${attemptNumber} falhou:`, error);
          
          // Só fecha o loading se for a última tentativa
          if (attemptNumber === maxAttempts) {
            this.$vs.loading.close();
          }
          return false;
        }
      };

      for (let attemptNumber = 1; attemptNumber <= maxAttempts; attemptNumber++) {
        const success = await makeAttempt(attemptNumber);
        
        if (success) return;

        if (attemptNumber < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, waitTime));
        } else {
          // Garante que o loading está fechado na última tentativa
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Não foi possível obter os dados de formações",
            text: "Tente novamente em alguns instantes, estamos processando o CV. Caso persista, o formato de CV não foi lido corretamente.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          });
        }
      }
    },

    goToSaveFormation(formation) {
      if (!formation) {
        this.$router.push({
          name: "formation-save",
          params: {
            formation,
          },
        });
        return;
      }

      this.$router.push({
        name: "formation-save",
        params: {
          formation,
        },
      });
    },

    handleEditPopupActive(formation) {
      this.payload = { ...formation };
      this.editPopupActive = true;
    },

    handleRemovePopupActive(formation) {
      this.formationToRemove = { ...formation };
      this.removePopupActive = true;
    },

    handleRemoveFormation() {
      this.$vs.loading({
        text: "Removendo...",
      });

      this.$http
        .delete(`api/v1/talents-formations/${this.formationToRemove.id}`)
        .then(async () => {
          this.$vs.loading.close();

          await this.$store.dispatch("formation/delete", {
            ...this.formationToRemove,
          });

          // PostHog: formation_removed
          (async () => {
            try {
              const { trackEvent } = await import("@/services/posthog");
              trackEvent("formation_removed", {
                id: this.formationToRemove.id,
                institute: this.formationToRemove.institute,
                scholarity: this.formationToRemove.scholarity,
              });
            } catch (_) {}
          })();

          this.removePopupActive = false;
          this.formationToRemove = {};

          this.calculateProgress({
            field: "formation",
            value: this.formations,
          });
        })
        .catch(async () => {
          this.$vs.loading.close();
          this.removePopupActive = false;
        });
    },

    handleEditFormation() {
      this.$vs.loading({
        text: "Salvando...",
      });

      this.editPopupActive = false;

      const { company_label } = this.$router.history.current.params;

      if (!this.payload.grade) this.payload.grade = "";

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=formations`, {
          formations: [
            {
              ...this.payload,
            },
          ],
        })
        .then(() => {
          this.$vs.loading.close();

          this.$store.dispatch("formation/update", {
            ...this.payload,
          });

          this.payload = {
            index: 0,
            popupActive: false,
            scholarity: "",
            institute: "",
            level: "",
            grade: "",
            to_date: "",
            from_date: "",
          };
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    handleSaveFormation() {
      this.$vs.loading({
        text: "Salvando...",
      });

      this.popupActive = false;

      const { company_label } = this.$router.history.current.params;

      if (!this.payload.grade) this.payload.grade = "";

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=formations`, {
          formations: [
            {
              ...this.payload,
            },
          ],
        })
        .then((response) => {
          this.$vs.loading.close();

          const { formations } = response.data.data;

          this.$store.dispatch("formation/store", {
            ...this.payload,
            id: formations[0].id,
            index: formations[0].index,
          });

          this.payload = {
            index: 0,
            popupActive: false,
            scholarity: "",
            institute: "",
            level: "",
            grade: "",
            to_date: "",
            from_date: "",
          };

          this.calculateProgress({
            field: "formation",
            value: this.formations,
          });
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    instituteAndScholarity({ institute, scholarity }) {
      if (
        institute !== undefined &&
        institute !== null &&
        scholarity !== undefined &&
        scholarity !== null
      ) {
        return institute.concat(` - ${scholarity}`);
      }

      if (
        institute !== undefined &&
        institute !== null &&
        (scholarity === undefined || scholarity === null)
      ) {
        return institute;
      }

      if (
        (institute === undefined || institute === null) &&
        scholarity !== undefined &&
        scholarity !== null
      ) {
        return scholarity;
      }
    },

    gradeAndLevel({ grade, level }) {
      if (
        grade !== undefined &&
        grade !== null &&
        level !== undefined &&
        level !== null
      ) {
        return grade.concat(` - ${level}`);
      }

      if (
        grade !== undefined &&
        grade !== null &&
        (level === undefined || level === null)
      ) {
        return grade;
      }

      if (
        (grade === undefined || grade === null) &&
        level !== undefined &&
        level !== null
      ) {
        return level;
      }
    },

    fromAndTo({ from_date, to_date, level }) {
      if (
        from_date !== null &&
        from_date !== undefined &&
        to_date !== null &&
        to_date !== undefined
      ) {
        return `Período: `
          .concat(`${from_date}`)
          .concat(
            `${level !== " Em andamento " ? " até " : " previsão de formação em "
            }`
          )
          .concat(`${to_date}`);
      }
    },

    ...mapActions("progress", ["calculateProgress"]),
  },
  components: {
    BackwardButton,
    ForwardButton,
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
</style>
